import React, { useState, useEffect, useRef } from 'react';
import { Icon, TextArea, TextAreaProps } from 'tea-component';
import './index.scss';

export default function AutoTextArea({
  value,
  onInput,
  style,
  placeholder,
  ...props
}: TextAreaProps & { placeholder?: string | React.ReactNode }) {
  const [height, setHeight] = useState('36px');
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textAreaRef.current) {
      if (value === '') {
        setHeight('36px');
      } else {
        setHeight(`${textAreaRef.current.scrollHeight}px`);
      }
    }
  }, [value]);

  // 监听输入框的实际内容，包括中文输入状态
  useEffect(() => {
    const createShouldShowPlaceholder = (flag: boolean) => () =>
      setShowPlaceholder(flag);

    const startFunc = createShouldShowPlaceholder(false);
    const endFunc = createShouldShowPlaceholder(true);

    // 监听 input 事件来捕获中文输入法的变化
    const textArea = textAreaRef.current;
    if (textArea) {
      textArea.addEventListener('compositionstart', startFunc);
      textArea.addEventListener('compositionend', endFunc);

      return () => {
        textArea.removeEventListener('compositionstart', startFunc);
        textArea.removeEventListener('compositionend', endFunc);
      };
    }
  }, [value]);

  return (
    <div className="auto-text-area-wrapper">
      <TextArea
        {...props}
        value={value}
        ref={textAreaRef}
        style={{ height, ...(style || {}) }}
        onInput={(value) => {
          if (textAreaRef.current) {
            // 实时更新高度以响应用户输入
            setHeight(`${textAreaRef.current.scrollHeight + 2}px`);
          }
          onInput?.(value);
        }}
      />

      {/* 自定义 HTML placeholder 覆盖层 */}
      {showPlaceholder && placeholder && !value && (
        <div className="custom-placeholder">
          {typeof placeholder === 'string' ? placeholder : placeholder}
        </div>
      )}

      {value && (
        <Icon
          onClick={() =>
            props?.onChange?.('', {
              context: { event: textAreaRef.current },
            } as any)
          }
          className="dbo-clear-btn"
          type="dismiss"
        />
      )}
    </div>
  );
}
